import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { METHOD: { POST } } = HOOKS_SETTINGS;
const { CONTROLLERS: { SET_UP_AUTO_SAVINGS: { BASE, VERSION } } } = USER;

export const useSetSumAutoSavingsQuery = ({ customerId, amount, onSuccess }: {customerId: string, amount:number, onSuccess?: () => void }) => useQuery(
  ['setAutoSavings'],
  async () => {
    if (!customerId) {
      return '';
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      method: POST,
      data: {
        amount,
        activate: true,
      },
    });
    return data;
  },
  {
    enabled: false,
    onSuccess: () => { if (onSuccess) onSuccess(); },
  },
);
